import MicroEmitter from 'micro-emitter';

export default class CustomSelect extends MicroEmitter {
	static CHANGE = 'customSelect_change';
	static REGISTERED_SELECTS = [];

	defaultOptions = {
		optionsSelector: '.js-customSelectOptions',
	};

	optionTemplate = null;
	optionsWrapper = null;

	constructor(el, options = {}) {
		super();
		if (typeof el === 'string') {
			this.root = document.querySelector(el);
		} else {
			this.root = el;
		}

		if (!this.root) return;

		this.onOptionClick = ::this.onOptionClick;

		this.clickTarget = this.root.querySelector('.js-customSelectClickTarget') || this.root;
		this.clickTarget.addEventListener('click', this.onClick.bind(this));

		const optionTemplateEl = this.root.querySelector('[data-template]');
		optionTemplateEl.removeAttribute('data-template');
		if (!optionTemplateEl) return;
		this.optionTemplate = optionTemplateEl.outerHTML;
		optionTemplateEl.parentNode.removeChild(optionTemplateEl);

		this.options = { ...this.defaultOptions, ...options };

		this.optionsWrapper = this.root.querySelector(this.options.optionsSelector);
		if (!this.optionsWrapper) return;
		CustomSelect.REGISTERED_SELECTS.push(this);

		document.addEventListener(
			'click',
			() => {
				this.root.classList.remove('is-open');
			},
			false
		);
	}

	onClick(e) {
		this.root.classList.toggle('is-open');
		CustomSelect.REGISTERED_SELECTS.forEach(select => {
			if (select !== this) {
				select.close();
			}
		});
		e.stopPropagation();
	}

	addSelectOption(data) {
		const newOption = this.createElementFromHTML(this.optionTemplate);
		newOption.dataset.value = data.value;
		newOption.dataset.key = data.key;

		for (const key in data.content) {
			if (Object.hasOwnProperty.call(data.content, key)) {
				const value = data.content[key];
				const domTarget = newOption.querySelector(`[data-option-${key}]`);
				if (domTarget) domTarget.innerHTML = value;
			}
		}

		this.optionsWrapper.appendChild(newOption);

		newOption.addEventListener('click', this.onOptionClick);
	}

	addSelectGroup(data) {
		const newOption = this.createElementFromHTML(this.optionTemplate);
		newOption.classList.add('custom-select__option--group');
		for (const key in data.content) {
			if (Object.hasOwnProperty.call(data.content, key)) {
				const value = data.content[key];
				const domTarget = newOption.querySelector(`[data-option-${key}]`);
				if (domTarget) domTarget.innerHTML = value;
			}
		}

		this.optionsWrapper.appendChild(newOption);
	}

	createElementFromHTML(htmlString) {
		var div = document.createElement('div');
		div.innerHTML = htmlString.trim();
		return div.firstChild;
	}

	onOptionClick(e) {
		const { value, key } = e.currentTarget.dataset;
		const text = e.currentTarget.querySelector('[data-option-text]').innerText;
		this.emit(CustomSelect.CHANGE, { value, key, text });
	}

	clear() {
		this.optionsWrapper.innerHTML = '';
	}

	updateState() {
		if (this.optionsWrapper.innerHTML === '') {
			this.root.classList.add('is-empty');
			this.root.classList.add('is-disabled');
		} else {
			this.root.classList.remove('is-empty');
			this.root.classList.remove('is-disabled');
		}
	}

	close() {
		this.root.classList.remove('is-open');
	}
}
